import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import './styles.scss'
import { locales } from '../../../i18n/config'
import Select from '../Form/Select'

const options = []
for (let [key, value] of Object.entries(locales)) {
  options.push({ label: value.name, value: key })
}

class LanguageChanger extends Component {
  changeLanguage = (e) => {
    this.props.i18n.changeLanguage(e.target.value).then(() => {})
  }

  render () {
    return (
      <div className="language-changer">
        <div>
          <Select options={options} selected={this.props.i18n.language} onChange={this.changeLanguage}/>
        </div>
      </div>
    )
  }
}

export default withTranslation()(LanguageChanger)
